// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react'
import { FooterControl, TransactionDevicesContainer } from '../components'
import { CurrentUser, Transaction } from '../services'
import './Home.scss'


interface ContainerProps {
  nav: HTMLIonNavElement
  transaction: Transaction
  user: CurrentUser
}


const TransactionDetail: React.FC<ContainerProps> = ({
  nav,
  transaction,
  user
}) => {
  if (!nav) { return null }
  return (
    <IonPage>
      <IonHeader collapse="fade">
        <IonToolbar no-border>
          <IonTitle size="large">{transaction.getDisplayName()}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent scrollY={false}>
        <TransactionDevicesContainer nav={nav} transaction={transaction} user={user}/>
      </IonContent>
      <FooterControl nav={nav} user={user}/>
    </IonPage>
  );
};

export  { TransactionDetail }
